module.exports = "/_next/static/images/CustomerDataFoundationMobile@2x-8b4798b7ea36e25af1d0a50a1702adb7.png";